import FadeIn from "react-fade-in";

export default function FAQ() {
  return (
    <FadeIn delay={100}>
      <div className="jumbotron">
        <h1>Frequently Asked Questions 🤔</h1>

        <p>
          <em>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt.
          </em>
        </p>

        <h3>
          <a
            id="lorem-ipsum-dolor-sit-amet"
            href="#lorem-ipsum-dolor-sit-amet"
          >
            Lorem ipsum dolor sit amet?
          </a>
        </h3>

        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
          ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo{" "}
          <a href="https://example.com">consequat</a>.
        </p>

        <h3>
          <a
            id="duis-aute-irure-dolor-in-reprehenderit"
            href="#duis-aute-irure-dolor-in-reprehenderit"
          >
            Duis aute irure dolor in reprehenderit?
          </a>
        </h3>

        <p>
          Duis aute irure dolor in reprehenderit in voluptate velit esse
          cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
          cupidatat non proident, sunt in culpa qui{" "}
          <code>published: false</code> officia deserunt{" "}
          <code>published: true</code> mollit anim id est laborum.
        </p>

        <h3>
          <a
            id="is-there-a-lorem-ipsum-guide"
            href="#is-there-a-lorem-ipsum-guide"
          >
            Is there a lorem ipsum guide?
          </a>
        </h3>

        <p>
          Sed ut perspiciatis unde omnis iste{" "}
          <a href="https://example.com">natus error sit</a>, you can also
          find it by clicking the "?" page in the{" "}
          <a href="https://example.com">voluptatem</a>.
        </p>

        <h3>
          <a
            id="accusantium-doloremque-laudantium"
            href="#accusantium-doloremque-laudantium"
          >
            Accusantium doloremque laudantium?
          </a>
        </h3>

        <p>
          Totam rem aperiam eaque ipsa quae ab illo inventore veritatis et
          quasi architecto beatae vitae dicta sunt explicabo.
        </p>

        <h3>
          <a
            id="nemo-enim-ipsam-voluptatem-quia-voluptas-sit-aspernatur-aut-odit-aut-fugit"
            href="#nemo-enim-ipsam-voluptatem-quia-voluptas-sit-aspernatur-aut-odit-aut-fugit"
          >
            Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit
            aut fugit?
          </a>
        </h3>

        <p>
          Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet,
          consectetur, adipisci velit, sed quia non numquam eius modi tempora.
        </p>

        <h3>
          <a
            id="ut-enim-ad-minima-veniam"
            href="#ut-enim-ad-minima-veniam"
          >
            Ut enim ad minima veniam?
          </a>
        </h3>

        <p>
          Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse
          quam nihil molestiae consequatur from{" "}
          <a href="https://example.com">your settings</a>, but note that you
          can only do this if both are connected to your account. If you have
          any issues with this, email{" "}
          <a href="mailto:example@example.com">example@example.com</a> and
          we'll take care of it.
        </p>

        <h3>
          <a
            id="vel-illum-qui-dolorem-eum-fugiat-quo-voluptas-nulla-pariatur"
            href="#vel-illum-qui-dolorem-eum-fugiat-quo-voluptas-nulla-pariatur"
          >
            Vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?
          </a>
        </h3>

        <p>
          At vero eos et accusamus et iusto odio dignissimos ducimus qui
          blanditiis praesentium voluptatum deleniti atque corrupti quos
          dolores et quas molestias excepturi.
        </p>

        <h3>
          <a
            id="sint-occaecati-cupiditate-non-provident"
            href="#sint-occaecati-cupiditate-non-provident"
          >
            Sint occaecati cupiditate non provident?
          </a>
        </h3>

        <p>Similique sunt in culpa qui officia deserunt mollitia animi:</p>

        <p>
          <a
            href="https://example.com"
            className="article-body-image-wrapper"
          >
            <img
              src="https://res.cloudinary.com/practicaldev/image/fetch/s--6IowK_B8--/c_limit%2Cf_auto%2Cfl_progressive%2Cq_auto%2Cw_880/https://dev-to-uploads.s3.amazonaws.com/i/nywq81sq9e2cz46g3yfa.png"
              alt=""
              loading="lazy"
            />
          </a>
        </p>

        <p>Nam libero tempore, cum soluta nobis est eligendi optio!</p>

        <p>
          <a
            href="https://example.com"
            className="article-body-image-wrapper"
          >
            <img
              src="https://res.cloudinary.com/practicaldev/image/fetch/s--vgbE90M2--/c_limit%2Cf_auto%2Cfl_progressive%2Cq_auto%2Cw_880/https://dev-to-uploads.s3.amazonaws.com/i/hbcz7f08a4psiaova7yf.png"
              alt=""
              loading="lazy"
            />
          </a>
        </p>
        <h3>
          <a
            id="temporibus-autem-quibusdam-et-aut-officiis-debitis"
            href="#temporibus-autem-quibusdam-et-aut-officiis-debitis"
          >
            Temporibus autem quibusdam et aut officiis debitis?
          </a>
        </h3>

        <p>
          Please create an issue on{" "}
          <a href="https://example.com">our repo</a>.
        </p>

        <h3>
          <a
            id="aut-rerum-necessitatibus-saepe-eveniet"
            href="#aut-rerum-necessitatibus-saepe-eveniet"
          >
            Aut rerum necessitatibus saepe eveniet?
          </a>
        </h3>

        <p>
          Please email{" "}
          <a href="mailto:example@example.com">example@example.com</a>.
        </p>

        <h3>
          <a
            id="ut-et-voluptates-repudiandae-sint-et-molestiae"
            href="#ut-et-voluptates-repudiandae-sint-et-molestiae"
          >
            Ut et voluptates repudiandae sint et molestiae?
          </a>
        </h3>

        <p>
          Itaque earum rerum hic tenetur a sapiente delectus, ut aut
          reiciendis voluptatibus maiores alias consequatur.{" "}
        </p>

        <p>
          Aut perferendis doloribus asperiores repellat, navigate to the
          article, scroll to the bottom and click report abuse.{" "}
        </p>

        <p>
          In general, you can fill out the{" "}
          <a href="https://example.com">report abuse</a> form.
        </p>

        <h3>
          <a
            id="curabitur-blandit-tempus-porttitor"
            href="#curabitur-blandit-tempus-porttitor"
          >
            Curabitur blandit tempus porttitor?
          </a>
        </h3>

        <p>
          Right now, we count on <a href="https://example.com">listings</a>{" "}
          and <a href="https://example.com">sponsors</a>. Cras mattis
          consectetur purus sit amet fermentum.
        </p>

        <h3>
          <a
            id="vestibulum-id-ligula-porta-felis-euismod-semper"
            href="#vestibulum-id-ligula-porta-felis-euismod-semper"
          >
            Vestibulum id ligula porta felis euismod semper?
          </a>
        </h3>

        <p>
          If you have questions about sponsorships (i.e. how to turn off
          sponsor displays), visit our{" "}
          <a href="https://example.com">sponsorship info</a> page.
        </p>

        <h3>
          <a
            id="donec-ullamcorper-nulla-non-metus-auctor"
            href="#donec-ullamcorper-nulla-non-metus-auctor"
          >
            Donec ullamcorper nulla non metus auctor?
          </a>
        </h3>

        <p>
          You'll find the option to delete your account in your{" "}
          <a href="https://example.com">settings</a>. Maecenas sed diam eget
          risus varius blandit sit amet non magna.{" "}
        </p>

        <p>
          If you require a full deletion, please e-mail{" "}
          <a href="mailto:example@example.com">example@example.com</a> with
          the subject line "Lorem Ipsum Delete Request" and we will ensure
          that any of your remaining data is purged from all systems.
        </p>

        <h3>
          <a
            id="fusce-dapibus-tellus-ac-cursus-commodo"
            href="#fusce-dapibus-tellus-ac-cursus-commodo"
          >
            Fusce dapibus, tellus ac cursus commodo?
          </a>
        </h3>

        <p>
          Yes, you own the rights to the content you create and post and you
          have the full authority to post, edit, and remove your content as
          you see fit.{" "}
        </p>

        <p>
          By posting content, you give us a nonexclusive license to publish
          it, including anything reasonably related to publishing it (like
          storing, displaying, reformatting, and distributing it).
        </p>

        <h3>
          <a
            id="nullam-quis-risus-eget-urna-mollis-ornare"
            href="#nullam-quis-risus-eget-urna-mollis-ornare"
          >
            Nullam quis risus eget urna mollis ornare?
          </a>
        </h3>

        <p>
          No ad will ever be placed next to a user's post without their
          consent in the matter.
        </p>

        <h3>
          <a
            id="etiam-porta-sem-malesuada-magna-mollis-euismod"
            href="#etiam-porta-sem-malesuada-magna-mollis-euismod"
          >
            Etiam porta sem malesuada magna mollis euismod?
          </a>
        </h3>

        <p>
          Include <code>cover_image: [url]</code> in the front matter of your
          post. For more information on our editor, check out our{" "}
          <a href="https://example.com">editor guide</a>.
        </p>

        <h3>
          <a
            id="cum-sociis-natoque-penatibus-et-magnis-dis-parturient-montes"
            href="#cum-sociis-natoque-penatibus-et-magnis-dis-parturient-montes"
          >
            Cum sociis natoque penatibus et magnis dis parturient montes?
          </a>
        </h3>

        <p>
          Comments are threaded with a maximum depth, and then they become
          flat. Vivamus sagittis lacus vel augue laoreet rutrum faucibus
          dolor auctor by replying to the last comment in the overall thread.
        </p>

        <h3>
          <a
            id="praesent-commodo-cursus-magna-vel-scelerisque-nisl-consectetur"
            href="#praesent-commodo-cursus-magna-vel-scelerisque-nisl-consectetur"
          >
            Praesent commodo cursus magna, vel scelerisque nisl consectetur?
          </a>
        </h3>

        <p>
          Yes. To hide a comment that was added to one of your posts, simply
          click the dropdown connected to the comment and select the "Hide"
          option. You can read our{" "}
          <a href="https://example.com">original changelog post</a> on the
          feature for more information.
        </p>

        <h3>
          <a
            id="aenean-lacinia-bibendum-nulla-sed-consectetur"
            href="#aenean-lacinia-bibendum-nulla-sed-consectetur"
          >
            Aenean lacinia bibendum nulla sed consectetur?
          </a>
        </h3>

        <p>
          Lorem ipsum dolor sit amet in general, but we do have an internal
          policy of not boosting posts through our social channels that have
          certain content in the title, so you might want to keep that in
          mind.
        </p>

        <h3>
          <a
            id="maecenas-faucibus-mollis-interdum"
            href="#maecenas-faucibus-mollis-interdum"
          >
            Maecenas faucibus mollis interdum?
          </a>
        </h3>

        <p>
          Yes, you can. The link for our main feed can be found here:{" "}
          <a href="https://example.com">https://example.com/feed</a>. For
          user-specific feeds, you can find them via{" "}
          <code>https://example.com/feed/username</code>. For tag-specific
          feeds, you can find them via{" "}
          <code>https://example.com/feed/tag/tagname</code>.
        </p>

        <h3>
          <a
            id="sed-ut-perspiciatis-unde-omnis-iste-natus-error-sit-voluptatem-accusantium"
            href="#sed-ut-perspiciatis-unde-omnis-iste-natus-error-sit-voluptatem-accusantium"
          >
            Sed ut perspiciatis unde omnis iste natus error sit voluptatem
            accusantium?
          </a>
        </h3>

        <p>
          The authorization page being talked about looks like the following:
        </p>

        <p>
          <a
            href="https://example.com"
            className="article-body-image-wrapper"
          >
            <img
              src="https://res.cloudinary.com/practicaldev/image/fetch/s--LTQiA9Be--/c_limit%2Cf_auto%2Cfl_progressive%2Cq_auto%2Cw_880/https://dev-to-uploads.s3.amazonaws.com/i/5rkd4thx2y29epj7dt7q.png"
              alt=""
              loading="lazy"
            />
          </a>
        </p>

        <p>
          Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut
          fugit, sed quia consequuntur. Here's a picture of our options and
          what we've chosen:
        </p>

        <p>
          <a
            href="https://example.com"
            className="article-body-image-wrapper"
          >
            <img
              src="https://res.cloudinary.com/practicaldev/image/fetch/s--IXC4O-w0--/c_limit%2Cf_auto%2Cfl_progressive%2Cq_auto%2Cw_880/https://dev-to-uploads.s3.amazonaws.com/i/m3wnwz9rdofwdljyn7w7.png"
              alt=""
              loading="lazy"
            />
          </a>
        </p>

        <p>
          We take a strong stance against collecting unnecessary data on our
          users as stated on our{" "}
          <a href="https://example.com">privacy page</a>.
        </p>

        <h3>
          <a
            id="ut-enim-ad-minima-veniam-quis-nostrum-exercitationem-ullam-corporis-suscipit-laboriosam"
            href="#ut-enim-ad-minima-veniam-quis-nostrum-exercitationem-ullam-corporis-suscipit-laboriosam"
          >
            Ut enim ad minima veniam, quis nostrum exercitationem ullam
            corporis suscipit laboriosam?
          </a>
        </h3>

        <p>
          The problem you're running into is because you must have one
          sign-in method always connected to your account.{" "}
        </p>

        <p>
          The easiest way to go about solving this issue is to add another
          sign-in method to your account. There are a couple of ways you can
          approach this…
        </p>

        <p>
          Firstly, you can add an account by{" "}
          <a href="https://example.com">creating one here</a> and then
          connecting it to your account via your{" "}
          <a href="https://example.com">settings</a>. Once you’ve done so,
          you can then disconnect your other account from your profile and
          add your desired account.
        </p>

        <p>
          Just scroll down underneath the "Danger Zone" and click "Remove"
          (whichever is applicable). After refreshing the page, you'll see
          the option to add the new account.
        </p>

        <p>
          If you’d rather not create a new account, you can use the same
          process above but connect an alternate account to your account
          instead prior to removing the account you'd like to remove.
        </p>

        <p>
          Alternatively, if you'd rather not connect another account to your
          account, you can create a new account with your desired sign-in
          method and email us at{" "}
          <a href="mailto:example@example.com">example@example.com</a>{" "}
          requesting that we merge your two accounts together. If this is
          the case, be prepared to prove ownership over both of your
          accounts.
        </p>

        <h3>
          <a
            id="quis-autem-vel-eum-iure-reprehenderit-qui-in-ea-voluptate"
            href="#quis-autem-vel-eum-iure-reprehenderit-qui-in-ea-voluptate"
          >
            Quis autem vel eum iure reprehenderit qui in ea voluptate?
          </a>
        </h3>

        <p>
          As part of our spam prevention defense, we do not currently offer
          folks the option to sign up via email.
        </p>

        <p>
          Right now we only offer the option to sign up using third-party
          sign-in. We offer traditional methods like Twitter, Apple, and
          GitHub, but also offer sign up via our own method which you can
          learn about here. In short, this will allow you to easily sign up
          with any community, or others.
        </p>
      </div>
    </FadeIn>
  );
}
